import React, { forwardRef, useCallback } from 'react';
import styles from './ProcessingTemplate.module.scss';

import { SnackbarContent, useSnackbar } from 'notistack';

import { Card, CircularProgress } from '@material-ui/core';

export const ProcessingTemplate = forwardRef(function ProcessingTemplate({ id, message }, ref) {
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  return (
    <SnackbarContent ref={ref}>
      <Card className={styles.card} onClick={handleDismiss}>
        <div className={styles.body}>
          <span className={styles.text}>{message}</span>
          <div className={styles.spinnerWrapper}>
            <CircularProgress size={24} className={styles.spinner} />
          </div>
        </div>
      </Card>
    </SnackbarContent>
  );
});
